<template>
  <div class="offerings">
    <section class="section container">
      <h1 class="is-size-2-touch page-header">Our Offerings</h1>
      <div class="columns">
        <div class="column is-one-third">
          <nav class="panel">
            <a
              v-for="tab in tabs"
              v-bind:key="tab.component"
              v-bind:class="[
                'panel-block is-size-6-touch',
                { active: currentTab.component === tab.component },
              ]"
              v-on:click="currentTab = tab"
            >
              <span class="panel-icon">
                <i :class="tab.icon" aria-hidden="true"></i>
              </span>
              {{ tab.title }}
            </a>
          </nav>
        </div>
        <div class="column">
          <div class="box">
            <component v-bind:is="currentTab.component" class="tab"></component>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import OfferingTAS from "@/components/offerings/TAS.vue";
import OfferingRPO from "@/components/offerings/RPO.vue";
import OfferingELS from "@/components/offerings/ELS.vue";
import OfferingLDI from "@/components/offerings/LDI.vue";
import OfferingHPM from "@/components/offerings/HPM.vue";
import OfferingHCC from "@/components/offerings/HCC.vue";
import OfferingPSH from "@/components/offerings/PSH.vue";

export default {
  name: "offerings",
  components: {
    OfferingTAS,
    OfferingRPO,
    OfferingPSH,
    OfferingELS,
    OfferingLDI,
    OfferingHPM,
    OfferingHCC,
  },
  data: function() {
    return {
      tabs: [
        {
          component: "OfferingTAS",
          title: "Talent Acquisition Services",
          icon: "fas fa-search",
        },
        {
          component: "OfferingRPO",
          title: "Recruitment Process Outsourcing",
          icon: "fas fa-filter",
        },
        {
          component: "OfferingPSH",
          title: "Culture, Diversity & POSH Advisory",
          icon: "fas fa-bullhorn",
        },
        {
          component: "OfferingELS",
          title: "Employee Leasing & Staffing",
          icon: "fas fa-book",
        },
        {
          component: "OfferingLDI",
          title: "Learning & Development Initiatives",
          icon: "fas fa-exchange-alt",
        },
        {
          component: "OfferingHPM",
          title: "HR Process Management",
          icon: "fas fa-sync-alt",
        },
        {
          component: "OfferingHCC",
          title: "Human Capital Consulting",
          icon: "fas fa-compass",
        },
      ],

      currentTab: {
        component: "OfferingTAS",
        title: "Talent Acquisition Services",
        icon: "fas fa-search",
      },
    };
  },
};
</script>
